export default __webpack_public_path__ + "static/media/bg_home.4a42624e.jpg";